import styled, { css } from 'styled-components';
import BaseLink from 'Elements/Link/Link';

export const SocialStyled = styled(BaseLink)`
    ${({ theme }) => css`
        border-radius: 0.5rem;
        border: ${theme.commonStyles.brandPixel} solid ${theme.colors.secondary.tints[2].hex};
        display: flex;
        align-items: center;
        justify-content: center;
        text-decoration: none;
        color: ${theme.colors.tertiary.hex};
        font-size: 1rem;
        font-weight: 700;
        line-height: 1.3;
        padding: 1rem 2rem;

        &:hover {
            text-decoration: underline;
        }

        @media ${theme.breakpoints.medium.media} {
            font-size: 1.25rem;
            justify-content: flex-start;
            padding: 1.2rem 2rem;
        }

        @media ${theme.breakpoints.large.media} {
            padding: 1rem 2rem;
        }
    `}
`;

export const IconStyled = styled.svg`
    width: 2.5rem;
    height: 2.5rem;
    margin-right: 1rem;
    color: var(--sup-social-colour);
`;
